import { useState, useCallback } from "react";
import LocalStore from "containers/LocalStore";
import { MiniSearchView, viewName } from "views/miniSearch";
import { compose } from "redux";
import TogglesHandler from "containers/TogglesHandler";
import SplitPanes from "containers/SplitPanes";
import { SearchScope } from "data/types";

const View = compose(
    TogglesHandler({ viewName }),
    SplitPanes({
        viewName,
        paneIds: ["#pickerForm", "#pickerResult"],
        toggleIds: ["search", "result"],
    })
)(MiniSearchView);

const SearchPicker = ({
    onClose,
    searchForm,
    onDocumentSelect,
    onFolderSelect,
    itemUri,
    topRowBefore,
    filters,
}) => {
    const [currentRow, setCurrentRow] = useState(searchForm);
    const [currentSearchResultRow, setCurrentSearchResultRow] = useState(-1);
    const handleSearchResultRowSelect = useCallback(
        (
            e: SyntheticMouseEvent<*>,
            rowIndex: number,
            row: SearchResultRowDTO
        ) =>
            setCurrentSearchResultRow(rowIndex) || row.isDoc
                ? onDocumentSelect(e, row.itemUri, rowIndex)
                : onFolderSelect(row.itemUri, rowIndex),
        [onDocumentSelect, onFolderSelect]
    );
    return (
        <LocalStore name="picker-modal">
            <View
                onClose={onClose}
                paneIds={["pickerMain", "pickerForm", "pickerResult"]}
                itemUri={itemUri}
                sf={{ currentRow, setCurrentRow }}
                sr={{
                    currentRow: currentSearchResultRow,
                    setCurrentRow: setCurrentSearchResultRow,
                }}
                onSearchResultRowClick={handleSearchResultRowSelect}
                actionsDisabled={true}
                topRowBefore={topRowBefore}
                filters={filters}
                searchScope={
                    itemUri ? SearchScope.AllFolders : SearchScope.AllSites
                }
            />
        </LocalStore>
    );
};
SearchPicker.displayName = "PickerModal.SearchPicker";

export default SearchPicker;
